import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod/v4";

import { useProfile } from "./get-profile";
import { createUserRequestFromAddress, updateUser } from "./utils";

import type { MutationConfig } from "@/lib/react-query";
import type { User } from "@/types/user";

export const addressSchema = z.object({
  address: z.string().optional(),
  city: z.string().optional(),
  country: z.string().optional(),
  postal_code: z.string().optional(),
});

export type AddAddressInput = z.infer<typeof addressSchema>;

type UseAddAddressOptions = {
  mutationConfig?: MutationConfig<(data: AddAddressInput) => Promise<User>>;
};

export const useAddAddress = ({ mutationConfig }: UseAddAddressOptions = {}) => {
  const queryClient = useQueryClient();
  const { data: user } = useProfile();
  const createRequest = createUserRequestFromAddress(user);

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: (data) => updateUser(createRequest(data)),
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.setQueryData(["profile"], data);
      onSuccess?.(data, variables, onMutateResult, context);
    },
    ...restConfig,
  });
};
